export const GOT_USER = 'GOT_USER';
export const USAGE = 'USAGE';
export const BANNER_TRIAL_ENDING_HIDDEN = 'BANNER_TRIAL_ENDING_HIDDEN';
export const VIEWS = 'VIEWS';
export const FEATURES = 'FEATURES';
